module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/GS-1feea45e2507f7c5245b9974e2fc8b20.png";